import React, { useContext, useEffect, useState } from "react";
import SystemContext from "../../../context/SystemContext";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Box,
  Container,
  Stack,
  Grid,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  useTheme
} from "@mui/material";
import InputButton from "../../UI/Inputs/InputButton/InputButton";
import moment from "moment";
import check from "../../../assets/images/check_renew_plan.svg";
import checkPurple from "../../../assets/images/check_purple.svg";
import { useTranslation } from "react-i18next";
import AsideMob from "../PaymentArea/Layout/AsideMob/AsideMob";

const RenewPlan = ({ Products }) => {
  const { t } = useTranslation();
  const { session } = useSelector((state) => state.session);
  const { infoUsers, updateTagUser,changePropertyUrl } = useContext(SystemContext);
  const [plan, setPlan] = useState({
    name: "",
    value: "",
    id: "",
    periodicity: "",
    dateExpiration: "",
    price: "",
  });
  const dispatch = useDispatch();
  const [baseProduct, setBaseProduct] = useState(null);
  const [urlRedirect, setUrlRedirect] = useState("");
  const [additionalBaseProduct, setAdditionalBaseProduct] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  useEffect(() => {
    changePropertyUrl("/comprar/renovar")
  }, []);
  useEffect(() => {
    if (infoUsers) {
      const base_product = infoUsers.lastPayment?.find(
        (product) => product.category === "BASE"
      )

      const additional_product = infoUsers.lastPayment?.find(
        (product) => product.category === "ADDITIONAL" && product.order_id === base_product.order_id && [5, 6].indexOf(product.product_id) > -1
      )

      if (additional_product) {
        setAdditionalBaseProduct(additional_product);
      }

      setBaseProduct(base_product);
    }
  }, [infoUsers]);

  const ChoosePlan = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChoosePlan",
        step: "SelectPlan",
      },
    });
  };

  const MAP_PLAN_INFO = {
    15: [
      t("purchase.unlimited_access_to_over_one_hundred_and_fifty_activities"),
      t("purchase.general_and_game_statistics"),
      t("purchase.access_to_goals_and_achievements"),
    ],
    13: [
      t("purchase.unlimited_access_to_over_one_hundred_and_fifty_activities"),
      t("purchase.invitation_for_ten_users"),
      t("purchase.general_and_game_statistics"),
      t("purchase.access_to_goals_and_achievements"),
    ],
    16: [
      t("purchase.unlimited_access_to_over_one_hundred_and_fifty_activities"),
      t("purchase.invitation_for_thirty_users"),
      t("purchase.general_and_game_statistics"),
      t("purchase.access_to_goals_and_achievements"),
    ],
    14: [
      t("purchase.unlimited_access_to_over_one_hundred_and_fifty_activities"),
      t("purchase.invitation_for_five_users"),
      t("purchase.general_and_game_statistics"),
      t("purchase.access_to_goals_and_achievements"),
    ]
  }
  const map_plan_to_url ={
    15:"individual",
    13:"profissional/10",
    16:"profissional/30",
    14:"familia"
  }

  const findProduct = (products, periodicity, product_id = null) => {
    if (!products) return null;

    const product =
      products &&
      products.periodicity.find(
        (product) =>
          product.id === product_id && product.periodicity === periodicity
      );

    return product
      ? product.price.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      })
      : null;
  };

  const GoToInvoiceData = () => {
    updateTagUser(["RENOVAR"])
    changePropertyUrl(urlRedirect)
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "PaymentArea",
        step: "InvoiceData",
        errorList: [],
      },
    });
  };

  useEffect(() => {
    if (infoUsers && Products && baseProduct) {

      let newPlan = {
        ...plan,
        periodicity:
          baseProduct.periodicity === "monthly" ||
            baseProduct.periodicity === "custom"
            ? "monthly"
            : "annual",
        dateExpiration: baseProduct.next_charge,
      }

      const mapOlderPlan = {
        legacy: () => {
          const periodicity = baseProduct &&
            (baseProduct.periodicity === "monthly" || baseProduct.periodicity === "custom")
            ? "monthly"
            : "annual";
          let product_id = 13
          let productName = "purchase.professional_plan_ten_users"
          if (additionalBaseProduct && additionalBaseProduct.product_id === 5) {
            product_id = 16
            productName = "purchase.professional_plan_thirty_users"
          }

          const resultPlan = findProduct(
            Products,
            periodicity,
            product_id
          );

          return {
            name: t(productName),
            id: [product_id],
            value: resultPlan,
          };
        },
        default: () => {
          return {
            name: baseProduct.name,
            id: [baseProduct.product_id],
            value: baseProduct.price.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }),
          };
        },
      };

      if (!baseProduct || [2].indexOf(baseProduct.product_id) > -1) {
        newPlan = { ...newPlan, ...mapOlderPlan["legacy"]() };
      } else {
        newPlan = { ...newPlan, ...mapOlderPlan["default"]() };
      }
      let newUrl = "/comprar/renovar"
      if(baseProduct.product_id in MAP_PLAN_INFO){
        newPlan.info = MAP_PLAN_INFO[baseProduct.product_id]
        newUrl = newUrl +"/"+ map_plan_to_url[baseProduct.product_id]
      }else{
        newPlan.info = MAP_PLAN_INFO[13];
        newUrl = newUrl+ "/"+ map_plan_to_url[13]
      }
      newUrl = newUrl + (newPlan.periodicity === "monthly" ? "/mensal" : "/anual")
      setUrlRedirect(newUrl)
      setPlan(newPlan);
    }
  }, [infoUsers, Products, baseProduct, additionalBaseProduct]);

  useEffect(() => {
    if (session && plan && infoUsers && baseProduct) {
      dispatch({
        type: "PURCHASE",
        PostData: {
          sub: session.sub,
          product_id: plan.id,
          email: session.email,
          periodicity:
            plan.periodicity === "monthly" ||
              plan.periodicity === "custom"
              ? "monthly"
              : "annual",
        },
        planInfo: {
          planName: plan.name,
          value: plan.value,
          planDescription: plan.info,
          periodicity:
            plan.periodicity === "monthly" ||
              plan.periodicity === "custom"
              ? "monthly"
              : "annual",
        },
      });
    }
  }, [plan, session, infoUsers]);

  const mobileContentSx = {
    p: 3,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  };

  const mobileTitleSx = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    mb: 2,
    color: '#662d91'
  };

  const titleSx = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    mb: 2
  };

  const textDescSx = {
    fontSize: '1rem',
    lineHeight: 1.5,
    mb: 1
  };

  const mobilePlanCardSx = {
    p: 3,
    textAlign: 'center',
    bgcolor: '#662d91',
    color: 'white',
    borderRadius: 2,
    boxShadow: 1,
    mb: 2
  };

  const planNameSx = {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    mb: 1
  };

  const planValueSx = {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'primary.main',
    mb: 0.5
  };

  const mobilePlanValueSx = {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'white',
    mb: 0.5
  };

  const desktopPlanValueSx = {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'white',
    mb: 0.5
  };

  const recurrenceSx = {
    fontSize: '0.875rem',
    color: 'text.secondary'
  };

  const mobileRecurrenceSx = {
    fontSize: '0.875rem',
    color: 'rgba(255, 255, 255, 0.7)'
  };

  const desktopRecurrenceSx = {
    fontSize: '0.875rem',
    color: 'rgba(255, 255, 255, 0.7)'
  };

  const infoListSx = {
    p: 0
  };

  const infoItemSx = {
    py: 0.5,
    px: 0,
    alignItems: 'flex-start'
  };

  const planImageSx = {
    width: 20,
    height: 20,
    mt: 0.25
  };

  const desktopCardSx = {
    p: 4,
    minHeight: 400
  };

  const desktopRightSectionSx = {
    bgcolor: '#662d91',
    color: 'white',
    borderRadius: 2,
    p: 3,
    textAlign: 'center'
  };

  const desktopLeftSectionSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%'
  };

  const linkButtonSx = {
    color: '#662d91',
    textTransform: 'none',
    fontSize: '0.875rem',
    fontWeight: 300,
    p: 0,
    minHeight: 'auto',
    textDecoration: 'underline',
    '&:hover': {
      bgcolor: 'transparent',
      textDecoration: 'underline'
    }
  };

  return plan ? (
    <>
      {isMobile ? (
        <>
          <Container maxWidth="sm" sx={mobileContentSx}>
            <Typography variant="h4" sx={mobileTitleSx}>
              {t("purchase.your_tuning_plan_won")}
            </Typography>

            <Typography sx={textDescSx}>
              {t("purchase.we_noticed_that_your_plan_expired_in")}{" "}
              <Box component="span" sx={{ fontWeight: 'bold' }}>
                {moment(plan?.dateExpiration).format("DD/MM/YYYY")}
              </Box>.
            </Typography>

            <Typography sx={textDescSx}>
              {t("purchase.renew_your_professional_plan")}
            </Typography>

            <Card sx={mobilePlanCardSx}>
              <Typography variant="subtitle1" sx={{ mb: 2, color: 'white' }}>
                {t("purchase.your_last_active_plan_is_equivalent_to")}
              </Typography>

              <Typography sx={{ ...planNameSx, color: 'white' }}>
                {plan.name}
              </Typography>

              <Typography sx={mobilePlanValueSx}>
                {plan.value}
              </Typography>

              <Typography sx={mobileRecurrenceSx}>
                {plan.periodicity === "monthly" ? t("purchase.per_month") : t("purchase.per_year")}
              </Typography>
            </Card>

            <List sx={infoListSx}>
              {plan?.info
                ? plan.info.map((item, index) => (
                  <ListItem key={index} sx={infoItemSx}>
                    <ListItemIcon sx={{ minWidth: 32 }}>
                      <Box
                        component="img"
                        src={checkPurple}
                        alt=""
                        sx={planImageSx}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{ fontSize: '0.875rem' }}
                    />
                  </ListItem>
                ))
                : null}
            </List>
          </Container>
          <AsideMob />
        </>
      ) : (
        <Container maxWidth="lg" sx={{ pt: '10%'}}>
          <Card sx={desktopCardSx}>
            <Grid container spacing={4} sx={{ height: '100%' }}>
              <Grid item xs={12} md={6}>
                <Box sx={desktopLeftSectionSx}>
                  <Stack spacing={3} alignItems="center">
                    <Typography variant="h4" sx={titleSx}>
                      {t("purchase.your_tuning_plan_won")}
                    </Typography>

                    <Typography sx={textDescSx}>
                      {t("purchase.we_noticed_that_your_plan_expired_in")}{" "}
                      <Box component="span" sx={{ fontWeight: 'bold' }}>
                        {moment(plan?.dateExpiration).format("DD/MM/YYYY")}
                      </Box>.
                    </Typography>

                    <Typography sx={textDescSx}>
                      {t("purchase.renew_your_professional_plan")}
                    </Typography>

                    {(plan && plan.value) ? (
                      <Stack spacing={2} alignItems="center">
                        <Button
                          data-testid="buy_renewPlan_btn"
                          onClick={GoToInvoiceData}
                          sx={{
                            background: '#662d91',
                            color: '#ffffff',
                            textTransform: 'none',
                            fontSize: '0.875rem',
                            fontWeight: 'bold',
                            minHeight: 'auto',
                            width: '100%',
                            p: 1,
                            borderRadius: 2,
                            textTransform: 'uppercase',
                            '&:hover': {
                              backgroundColor: '#4a1f6b',
                            }
                          }}
                        >
                          {t("purchase.renew_plan")}
                        </Button>
                        <Button
                          data-testid="buy_chooseAnotherPlan_btn"
                          onClick={ChoosePlan}
                          variant="text"
                          sx={linkButtonSx}
                        >
                          {t("purchase.i_want_to_choose_another_plan")}
                        </Button>
                      </Stack>
                    ) : null}
                  </Stack>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={desktopRightSectionSx}>
                  <Stack spacing={2}>
                    <Typography variant="h6" sx={{ color: 'white' }}>
                      {t("purchase.your_last_active_plan_is_equivalent_to")}
                    </Typography>

                    <Typography
                      data-testid='buy_renewLastPlanName_text'
                      sx={{ ...planNameSx, color: 'white' }}>
                      {plan.name}
                    </Typography>

                    <Typography
                      data-testid='buy_renewLastPlanValue_text'
                      sx={desktopPlanValueSx}>
                      {plan.value}
                    </Typography>

                    <Typography
                      data-testid='buy_renewLastPlanRecurrence_text'
                      sx={desktopRecurrenceSx}>
                      {plan.periodicity === "monthly" ? t("purchase.per_month") : t("purchase.per_year")}
                    </Typography>

                    <List sx={infoListSx}>
                      {plan?.info
                        ? plan.info.map((item, index) => (
                          <ListItem key={index} sx={infoItemSx}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <Box
                                component="img"
                                src={check}
                                alt=""
                                sx={planImageSx}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={item}
                              primaryTypographyProps={{
                                fontSize: '0.875rem',
                                color: 'white'
                              }}
                            />
                          </ListItem>
                        ))
                        : null}
                    </List>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Container>
      )}
    </>
  ) : null;
};

export default RenewPlan;